import React, { Component } from 'react';
import StartSection from '../../components/GamePage/StartSection/StartSection'
export default class CharSelectPage extends Component {
    render() {
        return (
            <StartSection></StartSection>
        )
    }
}